<template>
  <section class="app-carousels section" data-sectionThemeDark="false">
    <div 
      v-if="this.componentConfig.SlidersMobileActive" class="portfolio-container-mobile">
      <div
        v-show="this.componentConfig.appListMenuActive"
        class="portfolio-item-mobile-menu"
      >
        <ul>
          <li class="--stepp-assist">
            <router-link to="/AppScreensStepAssist">STEPP ASSIST</router-link>
          </li>
          <li class="--commrisk-assist">
            <router-link to="/AppScreensCommriskAssist">COMMRISK ASSIST</router-link>
          </li>
          <li class="--orange-assist">
            <router-link to="/AppScreensOrangeAssist">HOWDIE ASSIST</router-link>
          </li>
          <li class="--integritas-assist">
            <router-link to="/AppScreensIntegritasAssist">INTEGRITAS ASSIST</router-link>
          </li>
          <li class="--frontline">
              <router-link to="/AppScreensFrontlineAssist">FRONTLINE ASSIST</router-link>
          </li>
          <li class="--twk-assist">
            <router-link to="/AppScreensTWKAssist">TWK ASSIST</router-link>
          </li>
        </ul>
      </div>
      <div
        v-show="this.slidersStates.showSliderActive"
        class="portfolio-container-mobile"
      >
        <div class="portfolio-item-mobile  ">
          <a @click="openAppMenu()"
            ><div class="menu icon icon-back-button --tert"></div>
          </a>

          <div class="portfolio-item-container">
            <div class="portfolio-item ">
                 
              <hooper
                ref="slider"
                style="height: 900px; width:375px;opacity:0;"
                :auto-play="true"
                :play-speed="4000"
              >
                <template v-for="val in ShowSlideList"  >
                     
                  <slide v-for="item in val.Items" :key="item.id">
                    <img
                      :src="
                        require('../../' +
                          'assets/imgs/our-apps-screens' +
                          '/' +
                          item.image)
                      "
                      class="slider-item"
                      alt=""
                    />
                  </slide>
                </template>

                 <!--<slide v-for="ShowSlideList.Item in ShowSlideList.Items" :key="ShowSlideList.Item.id" :index="ShowSlideList.Item.id">
                                        <img v-bind:src="require('../../'+'assets/imgs/our-apps-screens'+'/' + ShowSlideList.Item.image)" alt=""  />
                                    </slide>--> 

                 <!--<slide v-for="(ShowSlideListi.Items, indx) in ShowSlideList" :key="indx" :index="indx">
                                        {{ShowSlideListItem.Items.id }}
                                        <img v-bind:src="require('../../'+'assets/imgs/our-apps-screens'+'/' + ShowSlideListItem.Items.image)" alt=""  />
                                    </slide>--> 

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
              </hooper>
            </div>
            <!-- <p>STEPP ASSIST</p> -->
            <p>{{ this.slidersStates.Title }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Desktop  -->

    <div v-else  class="portfolio-container">
      <div class="portfolio-item-container">
        <div class="portfolio-item ">
          <div class="phone-frame"></div>
          <hooper
            style="height: 360px; width:201px;"
            :auto-play="true"
            :play-speed="4000"
          >
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/stepp-assist/1-Stepp-Splash-Page-MVP-Option-2.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/stepp-assist/2-Stepp-Walkthrough-One-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/stepp-assist/3-Stepp-Home-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/stepp-assist/4-Stepp-Live-Chat-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/stepp-assist/5-Stepp-Populated-Details-Page.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/stepp-assist/6-Stepp-Roadside-Information-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <hooper-navigation slot="hooper-addons"></hooper-navigation>
          </hooper>
        </div>
        <p>STEPP ASSIST</p>
      </div>
      <div class="portfolio-item-container">
        <div class="portfolio-item ">
          <div class="phone-frame"></div>
          <hooper
            style="height: 360px; width:201px;"
            :auto-play="true"
            :play-speed="4000"
          >
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/commrisk-assist/1-Commrisk-Splash-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/commrisk-assist/2-Commrisk-Walkthrough-One-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/commrisk-assist/3-Commrisk-Home-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/commrisk-assist/4-Commrisk-Live-Chat-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/commrisk-assist/5-Commrisk-Populated-Details-Page.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/commrisk-assist/6-Commrisk-Roadside-Information-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <hooper-navigation slot="hooper-addons"></hooper-navigation>
          </hooper>
        </div>
        <p>COMMRISK ASSIST</p>
      </div>

      <div class="portfolio-item-container">
        <div class="portfolio-item ">
          <div class="phone-frame"></div>
          <!--  insurance-zone -->
          <hooper
            style="height: 360px; width:201px;"
            :auto-play="true"
            :play-speed="4000"
          >
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/howdie/1-Howdie-Splash-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/howdie/2-Howdie-Walkthrough-One-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/howdie/3-Howdie-Home-Page-Banner-1.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/howdie/4-Howdie-Populated-Details-Page.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/howdie/5-Howdie-Geyser-Step-4-Photos-Preview-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/howdie/6-Accident-Assist-Step-2.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <hooper-navigation slot="hooper-addons"></hooper-navigation>
          </hooper>
        </div>
        <p>HOWDIE ASSIST</p>
      </div>

      <div class="portfolio-item-container">
        <div class="portfolio-item ">
          <div class="phone-frame"></div>
          <!--  integritas assist -->
          <hooper
            style="height: 360px; width:201px;"
            :auto-play="true"
            :play-speed="4000"
          >
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/integritas-assist/1-Integras-Splash-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/integritas-assist/2-Integras-Walkthrough-One-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/integritas-assist/3-Integras-Home-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/integritas-assist/4-Integras-Live-Chat-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/integritas-assist/5-Integras-Populated-Details-Page.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/integritas-assist/6-Integras-Roadside-Information-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <hooper-navigation slot="hooper-addons"></hooper-navigation>
          </hooper>
        </div>
        <p>INTEGRITAS ASSIST</p>
      </div>

      <div class="portfolio-item-container">
        <div class="portfolio-item ">
          <div class="phone-frame"></div>
          <!--  frontline -->
          <hooper
            style="height: 360px; width:201px;"
            :auto-play="true"
            :play-speed="4000"
          >
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/frontline/1-Frontline-Splash-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/frontline/2-Frontline-Walkthrough-One-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/frontline/3-Frontline-Home-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/frontline/4-Frontline-Live-Chat-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/frontline/5-Frontline-Populated-Details-Page.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/frontline/6-Frontline-Roadside-Information-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <hooper-navigation slot="hooper-addons"></hooper-navigation>
          </hooper>
        </div>
        <p>FRONTLINE ASSIST</p>
      </div>

      <div class="portfolio-item-container">
        <div class="portfolio-item ">
          <div class="phone-frame"></div>
          <!--  twk assist -->
          <hooper
            style="height: 360px; width:201px;"
            :auto-play="true"
            :play-speed="4000"
          >
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/twk-assist/1-TWK-Splash-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/twk-assist/2-TWK-Walkthrough-One-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/twk-assist/3-TWK-Home-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/twk-assist/4-TWK-Live-Chat-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/twk-assist/5-TWK-Populated-Details-Page.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <slide>
              <img
                src="../../assets/imgs/our-apps-screens/twk-assist/6-TWK-Roadside-Information-Page-MVP.png"
                alt="slide 1"
                class="slider-item"
              />
            </slide>
            <hooper-navigation slot="hooper-addons"></hooper-navigation>
          </hooper>
        </div>
        <p>TWK ASSIST</p>
      </div>
    </div>
  </section>
</template>
<script>
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper'

export default {
  name: 'OurAppSliders',
  components: {
    Hooper,
    Slide,
    HooperNavigation
  },
  data() {
      return {
      componentConfig: {
        SlidersMobileActive: false,
        appListMenuActive: true
      },
      slidersStates: {
        showSliderActive: false,
        Title: 'test'
      },
      sliderMenuItems: [
        {
          sliderID: 1,
          sliderTitle: 'Stepp Assist',
          sliderName: 'Stepp',
          sliderSectionActive: false,
          sliderActive: true
        },
        {
          sliderID: 2,
          sliderTitle: 'Commrisk Assist',
          sliderName: 'Commrisk',
          sliderSectionActive: false,
          sliderActive: true
        },
        {
          sliderID: 3,
          sliderTitle: 'ORANGE ASSIST',
          sliderName: 'ORANGE',
          sliderSectionActive: false,
          sliderActive: true
        },
        {
          sliderID: 4,
          sliderTitle: 'INTEGRITAS ASSIST',
          sliderName: 'INTEGRITAS',
          sliderSectionActive: false,
          sliderActive: true
        },
        {
          sliderID: 5,
          sliderTitle: 'SUPERVALUE ASSIST',
          sliderName: 'SUPERVALUE',
          sliderSectionActive: false,
          sliderActive: true
        },
        {
          sliderID: 6,
          sliderTitle: 'TWK ASSIST',
          sliderName: 'TWK',
          sliderSectionActive: false,
          sliderActive: true
        }
      ],
      ShowSlideList: [{
          Id: 1,
          Title: 'Stepp',
          Items: [{
              id: 0,
              image: 'stepp-assist/1-stepp-assist-walkthrough.jpg',
              title: 'Stepp Assist',
              active: true,
              sortOrder: 1
            }]
      }],
      SteppSlideList: [{
          Id: 1,
          Title: 'Stepp',
          Items: [
            {
              id: 0,
              image: 'stepp-assist/1-stepp-assist-walkthrough.jpg',
              title: 'Stepp Assist',
              active: true,
              sortOrder: 1
            },
            {
              id: 1,
              image: 'stepp-assist/2-stepp-assist-menu.jpg',
              title: 'Stepp Assist',
              active: true,
              sortOrder: 2
            },
            {
              id: 2,
              image: 'stepp-assist/3-stepp-assist-home.jpg',
              title: 'Stepp Assist',
              active: true,
              sortOrder: 3
            },
            {
              id: 3,
              image: 'stepp-assist/4-stepp-assist-chat.jpg',
              title: 'Stepp Assist',
              active: true,
              sortOrder: 4
            },
            {
              id: 4,
              image: 'stepp-assist/5-stepp-assist-emergency-assist.jpg',
              title: 'Stepp Assist',
              active: true,
              sortOrder: 5
            },
            {
              id: 5,
              image: 'stepp-assist/6-stepp-assist-personal.jpg',
              title: 'Stepp Assist',
              active: true,
              sortOrder: 6
            }
          ]
      }],
      CommriskSlideList:[{
          Id:2,
          Title:"Commrisk",
          Items:[
              {
                  id:0,
                  image:"commrisk-assist/1-commrisk-walkthrough.png",
                  active:true,
                  sortOrder:1
              },
              {
                  id:1,
                  image:"commrisk-assist/2-commrisk-menu.jpg",
                  active:true,
                  sortOrder:2
              },
              {
                  id:2,
                  image:"commrisk-assist/3-commrisk-home.png",
                  active:true,
                  sortOrder:3
              },
              {
                  id:3,
                  image:"commrisk-assist/4-commrisk-chat.jpg",
                  active:true,
                  sortOrder:4
              },
              {
                  id:4,
                  image:"commrisk-assist/5-commrisk-emergency.png",
                  active:true,
                  sortOrder:5
              },
              {
                  id:5,
                  image:"commrisk-assist/6-commrisk-personal-details.jpg",
                  active:true,
                  sortOrder:6
              }
          ]
      }],
      OrangeSlideList:[{
          Id:3,
          Title:"Orange Assist",
          Items:[
              {
                  id:0,
                  image:"orange-assist/1-insurance-zone-walkthrough.jpg",
                  active:true,
                  sortOrder:1
              },
              {
                  id:1,
                  image:"orange-assist/2-insurance-zone-menu.jpg",
                  active:true,
                  sortOrder:2
              },
              {
                  id:2,
                  image:"orange-assist/3-insurance-zone-home.jpg",
                  active:true,
                  sortOrder:3
              },
              {
                  id:3,
                  image:"orange-assist/4-insurance-zone-chat.jpg",
                  active:true,
                  sortOrder:4
              },
              {
                  id:4,
                  image:"orange-assist/5-insurance-zone-emergency-assist.jpg",
                  active:true,
                  sortOrder:5
              },
              {
                  id:5,
                  image:"orange-assist/6-insurance-zone-personal.jpg",
                  active:true,
                  sortOrder:6
              }
          ]
      }],
      IntegritasSlideList:[{
          Id:4,
          Title:"Integritas Assist",
          Items:[
              {
                  id:0,
                  image:"integritas-assist/1-integritas-assist-walkthrough.jpg",
                  active:true,
                  sortOrder:1
              },
              {
                  id:1,
                  image:"integritas-assist/2-integritas-assist-menu.jpg",
                  active:true,
                  sortOrder:2
              },
              {
                  id:2,
                  image:"integritas-assist/3-integritas-assist-home.jpg",
                  active:true,
                  sortOrder:3
              },
              {
                  id:3,
                  image:"integritas-assist/4-integritas-assist-chat.jpg",
                  active:true,
                  sortOrder:4
              },
              {
                  id:4,
                  image:"integritas-assist/5-integritas-assist-emergency-assist.jpg",
                  active:true,
                  sortOrder:5
              },
              {
                  id:5,
                  image:"integritas-assist/6-integritas-assist-personal-details.jpg",
                  active:true,
                  sortOrder:6
              }
          ]
      }],
      SupervalueSlideList:[{
          Id:5,
          Title:"Frontline Assist",
          Items:[
              {
                  id:0,
                  image:"frontline/1-frontline-walkthrough.jpg",
                  active:true,
                  sortOrder:1
              },
              {
                  id:1,
                  image:"frontline/2-frontline-menu.jpg",
                  active:true,
                  sortOrder:2
              },
              {
                  id:2,
                  image:"frontline/3-frontline-home.jpg",
                  active:true,
                  sortOrder:3
              },
              {
                  id:3,
                  image:"frontline/4-frontline-chat.jpg",
                  active:true,
                  sortOrder:4
              },
              {
                  id:4,
                  image:"frontline/5-frontline-emergency.jpg",
                  active:true,
                  sortOrder:5
              },
              {
                  id:5,
                  image:"frontline/6-frontline-personal-details.jpg",
                  active:true,
                  sortOrder:6
              }
          ]
      }],
      TWKSlideList:[{
          Id:6,
          Title:"TWK Assist",
          Items:[
              {
                  id:0,
                  image:"twk-assist/1-twk-assist-walkthrough.jpg",
                  active:true,
                  sortOrder:1
              },
              {
                  id:1,
                  image:"twk-assist/2-twk-assist-menu.jpg",
                  active:true,
                  sortOrder:2
              },
              {
                  id:2,
                  image:"twk-assist/3-twk-assist-home.jpg",
                  active:true,
                  sortOrder:3
              },
              {
                  id:3,
                  image:"twk-assist/4-twk-assist-chat.jpg",
                  active:true,
                  sortOrder:4
              },
              {
                  id:4,
                  image:"twk-assist/5-twk-assist-emergency.jpg",
                  active:true,
                  sortOrder:5
              },
              {
                  id:5,
                  image:"twk-assist/6-twk-assist-personal-details.jpg",
                  active:true,
                  sortOrder:6
              }
          ]
      }]
    }
  },
  created: function() {
    const w = window.innerWidth
    if (w < 768) {
      //  this.SlidersMobileActive = !this.SlidersMobileActive;
      this.componentConfig.SlidersMobileActive = true
    } else {
      this.componentConfig.SlidersMobileActive = false
      //  this.SlidersFullLayoutActive = !this.SlidersFullLayoutActive;
    }
  },
  methods: {
    openAppMenu() {
      this.componentConfig.appListMenuActive = !this.componentConfig
        .appListMenuActive
      this.slidersStates.showSliderActive = !this.slidersStates.showSliderActive
    },
    populateShowSlides(obj) {
      const arrayName = obj

      if (arrayName === 'Stepp') {
        // console.log('made it')
        this.ShowSlideList = [...this.SteppSlideList];
        // this.slidersStates.sliderTitle = this.SteppSlideListItems.title;
        // this.slidersStates.sliderTitle = this.sliderMenuItems.filter(sliderMenuItems.id);
        // console.log(" this.slidersStates.sliderTitle:" + this.slidersStates.sliderTitle)
        this.toggleAndRefresh();
      }
      if(arrayName === 'Commrisk'){
          this.ShowSlideList = [...this.CommriskSlideList];
          this.toggleAndRefresh();
      }
      if(arrayName === 'Orange'){
          this.ShowSlideList = [...this.OrangeSlideList];
          this.toggleAndRefresh();
      }
      if(arrayName === 'Integritas'){
          this.ShowSlideList = [...this.IntegritasSlideList];
          this.toggleAndRefresh();
      }
      if(arrayName === 'Frontline'){
          this.ShowSlideList = [...this.SupervalueSlideList];
          this.toggleAndRefresh();
      }
      if(arrayName === 'TWK'){
          this.ShowSlideList = [...this.TWKSlideList];
          this.toggleAndRefresh();
      }
    },
    toggleAndRefresh() {
      this.componentConfig.appListMenuActive = !this.componentConfig.appListMenuActive
      this.slidersStates.showSliderActive = !this.slidersStates.showSliderActive
      return this.$nextTick().then(() => {
        this.$refs.slider.update()
      })
    }
  }
}
</script>
<style>
/* .hooper-slide {
  height: 200px;
  background-color: #62caaa;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  border: 2px solid #fff;
  font-size: 30px;
  border-radius: 10px;
}
.is-active {
  background-color: rgb(71, 218, 127);
}
.hooper-slide img {
  width: 100%;
} */
</style>
